import Component from '../core/Component'

export default class AsideOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const target = document.getElementById('aside')

        if (!target) {
            return
        }

        const aside = Component.getFromElement(target)

        if (aside) {
            aside.open()
        }
    }

}